import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    BasicTable,
    Select,
} from "extranet-component-library";
import { getHours, isMobile } from "../utils/parsers";


interface CustomProps {
    nextHours: Array<any>;
}

const NextHours = ({ nextHours }: CustomProps) => {
    const { t } = useTranslation();
    const [stop, setStop] = useState(0);

    return (
        <div className="nt-promos">
            <div className="title">{t("next_hour")}</div>
            {nextHours && nextHours.length ? (
                <>
                    <div className="select-stop">
                        <div className="select-title">
                            {t("select_stop")}
                        </div>
                        <Select
                            isMobile={isMobile()}
                            options={nextHours.map((h: any) => h.stop)}
                            placeholder=""
                            value={nextHours[stop].stop}
                            onSelect={(l: any) =>
                                setStop(nextHours.findIndex((s) => s.stop === l))
                            }
                        />
                    </div>
                    <div className="scroller">
                        <BasicTable
                            items={getHours(nextHours[stop].hours)}
                            emptyString={t("no_items")}
                            headers={[
                                { id: "lcod", label: "" },
                                { id: "snam", label: "" },
                                { id: "aet", label: "" },
                            ]}
                        />
                    </div>
                </>
            ) : (
                <div data-testid="no-data" className="no-items">
                    {t("no_items")}
                </div>
            )}
        </div>
    );
};

export default NextHours;
